import { parseISO, isValid, differenceInCalendarDays } from 'date-fns';

/** Inverse of PlannerPage's dateForCell: given a planner and a real
 *  calendar date, returns which (week, day) curriculum cell it falls on,
 *  or null if it's outside the term or falls on a weekend. */
export function cellForDate(planner, date) {
  if (!planner?.term_start) return null;
  const termStart = parseISO(planner.term_start);
  if (!isValid(termStart)) return null;
  const diff = differenceInCalendarDays(date, termStart);
  if (diff < 0) return null;
  const week = Math.floor(diff / 7) + 1;
  const day = (diff % 7) + 1; // 1=Mon..7=Sun
  if (day > 5 || week > (planner.weeks || 0)) return null;
  return { week, day };
}

export function timeToMinutes(time) {
  const [h, m] = time.split(':').map(Number);
  return h * 60 + m;
}

export function minutesToTime(minutes) {
  const h = Math.floor(minutes / 60).toString().padStart(2, '0');
  const m = (minutes % 60).toString().padStart(2, '0');
  return `${h}:${m}`;
}

/** Places flexible (no explicit time) items back-to-back starting at
 *  dayStartTime, pushing them past any fixed-time item they'd otherwise
 *  collide with. Fixed items always keep their explicit time. Returns
 *  everything sorted chronologically by start_time. */
export function placeActivities({ fixedItems, flexibleItems, dayStartTime }) {
  const fixed = [...fixedItems]
    .map(item => ({ ...item, start_time: item.start_time, end_time: minutesToTime(timeToMinutes(item.start_time) + item.duration_minutes) }))
    .sort((a, b) => timeToMinutes(a.start_time) - timeToMinutes(b.start_time));

  const placedFlexible = [];
  let cursor = timeToMinutes(dayStartTime);

  for (const item of flexibleItems) {
    // If placing here would overlap an upcoming fixed item, jump past it first.
    for (const f of fixed) {
      const fStart = timeToMinutes(f.start_time);
      const fEnd = timeToMinutes(f.end_time);
      if (cursor < fEnd && cursor + item.duration_minutes > fStart) {
        cursor = fEnd;
      }
    }
    const start = cursor;
    const end = start + item.duration_minutes;
    placedFlexible.push({ ...item, start_time: minutesToTime(start), end_time: minutesToTime(end) });
    cursor = end;
  }

  return [...fixed, ...placedFlexible].sort(
    (a, b) => timeToMinutes(a.start_time) - timeToMinutes(b.start_time)
  );
}
